export default __webpack_public_path__ + "static/media/logo1.8265955e.png";